import { createContext, useContext, type ReactNode } from 'react';
import type { ConsoleDataPort, Role } from '../data/port.js';
import type { Sessao } from '../data/session.js';

export interface AppState {
  /** Fonte de dados: adapter HTTP (logado) ou amostra em memória. */
  data: ConsoleDataPort;
  /** Papéis do operador. */
  roles: Role[];
  /** Quem está logado. */
  sessao: Sessao | null;
  /** Encerra a sessão e devolve a URL de logout do Keycloak, se houver. */
  sair: () => Promise<string | null>;
}

const AppContext = createContext<AppState | null>(null);

export function AppProvider({ value, children }: { value: AppState; children: ReactNode }) {
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp(): AppState {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useApp fora do AppProvider');
  return ctx;
}

/**
 * O papel autoriza a ação?
 *
 * Isto é só UX — esconder botão, avisar. A checagem que vale é a do servidor,
 * que revalida o papel e devolve 403. `console-admin` pode tudo.
 */
export function useCan(...permitidos: Role[]): boolean {
  const { roles } = useApp();
  if (roles.includes('console-admin')) return true;
  return permitidos.some((papel) => roles.includes(papel));
}
